import { Route } from "react-router-dom";
import DashboardLayout from "../Layouts/MainPage/Dashboard";
import Dashboard from "../Views/Web/Dashboard";
import CalenderIndex from "../Views/Web/Dashboard/CalenderIndex";

function DashboardRoutes() {
  return (
    <Route path="dashboard" element={<DashboardLayout />}>
      <Route index element={<Dashboard />} />
      <Route path="calender" element={<CalenderIndex />} />
    </Route>
  );
}

export default DashboardRoutes;